// Canonical B2C portal event names. Kept in sync with the backend whitelist in
// backend/myapp/journey_events.py (CLIENT_EVENT_WHITELIST). Use these constants
// instead of magic strings at the emit sites.

export const EVENTS = {
  // Post-interview screen (emitted via the voice-room beacon, meeting-keyed).
  POST_INTERVIEW_CTA_CLICKED: "post_interview_cta_clicked",
  // Auth (emitted via the journey beacon, uid-keyed).
  AUTH_SIGNUP_COMPLETE: "auth_signup_complete",
  AUTH_LOGIN_SUCCESS: "auth_login_success",
  // Candidate portal.
  APPLICATIONS_VIEWED: "applications_viewed",
  RECORDING_WATCH_STARTED: "recording_watch_started",
  VIDEO_PLAY: "video_play",
  VIDEO_PAUSE: "video_pause",
  VIDEO_MILESTONE: "video_milestone",
  VIDEO_COMPLETE: "video_complete",
  REEL_OPENED: "reel_opened",
  CLIP_PLAY: "clip_play",
  CLIP_COMPLETE: "clip_complete",
  REPORT_LOADED: "report_loaded",
  // The recruiter opened the recording at a flagged answer (answer-read row).
  ANSWER_READ_WATCH: "answer_read_watch",
  // The recruiter saw the "Does the story hold together" section, and opened the
  // recording at one of its lines (props: meetingId; watch also kind, status).
  STORY_CHECK_VIEWED: "story_check_viewed",
  STORY_CHECK_WATCH_CLICKED: "story_check_watch_clicked",
  TRIGGER_CLICKED: "trigger_clicked",
  // Conversion intent.
  PLAN_VIEWED: "plan_viewed",
  CHECKOUT_STARTED: "checkout_started",
  CHECKOUT_COMPLETED: "checkout_completed",
  // Hiring link (recruiter wizard + role page) and its public apply page.
  HIRING_LINK_CREATED: "hiring_link_created",
  HIRING_LINK_COPIED: "hiring_link_copied",
  HIRING_LINK_OPENED: "hiring_link_opened",
  // props.action: opened | downloaded | poster_printed.
  HIRING_LINK_QR: "hiring_link_qr",
  APPLY_CODE_REQUESTED: "apply_code_requested",
  APPLY_CODE_REJECTED: "apply_code_rejected",
  APPLY_INTERVIEW_STARTED: "apply_interview_started",
  // The resume bar was saved: props from, to, source (role_page | role_form).
  RESUME_BAR_CHANGED: "resume_bar_changed",
  // A JD was pasted or uploaded in the role form: props method (paste | file), filled (field count).
  JD_IMPORTED: "jd_imported",
  // The owner chose no application form questions in the role form: props mode (create | edit).
  ROLE_FORM_QUESTIONS_SKIPPED: "role_form_questions_skipped",
  // A call upload refused in the dialog before it started: props code, entry, role_id, source=client.
  // The backend logs the same name with source=server.
  CALL_UPLOAD_REFUSED: "call_upload_refused",
  // Nova beside a call (docs/COPILOT.md, "Record pages"). Tab: props tab (summary | nova).
  CALL_TAB_SELECTED: "call_tab_selected",
  // A starter tapped in Ask Nova on a call: props starter (pay | submittal | profile | email).
  NOVA_CALL_STARTER: "nova_call_starter",
  // A moment Nova cited was played: props seconds.
  NOVA_CALL_CITATION_PLAYED: "nova_call_citation_played",
  // The optional "Who are you hiring for?" question after sign-up.
  SIGNUP_PERSONA_ANSWERED: "signup_persona_answered",
  // The quick-start film a new account sees first (components/dashboard/WelcomeFilm).
  ONBOARDING_WELCOME_SHOWN: "onboarding_welcome_shown",
  ONBOARDING_WELCOME_SOUND_ON: "onboarding_welcome_sound_on",
  ONBOARDING_WELCOME_SKIPPED: "onboarding_welcome_skipped",
  ONBOARDING_WELCOME_COMPLETED: "onboarding_welcome_completed",
  // The "How it works" player (components/copilot/ScheduleInterviewFilm); props film, placement, language.
  ONBOARDING_FILM_PLAY: "onboarding_film_play",
  ONBOARDING_FILM_COMPLETE: "onboarding_film_complete",
} as const;

export type JourneyEventName = (typeof EVENTS)[keyof typeof EVENTS];
